import { Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import styles from "./SignUpPlanStyle.module.scss";
import ExplorePlans from "../ExplorePlans/ExplorePlans";
import { formatIndianCurrency } from "../../../../Utils/utils";

function SignUpPlan(props) {
  const {
    icon,
    planName,
    monthPrice,
    yearPrice,
    otherPlans,
    country,
    onPlanSelect,
    planImages,
    noOfSites,
    planType,
    setPlanType,
    explorePlans,
    setExplorePlans,
    licenseInfo,
    toggleType,
    setToggleType,
    newPlan,
    setNewPlan,
    setPlanPrice,
    initialPlan,
    onCancel,
    userDetails,
    setIsData,
    setCouponCode,
    setShowInput,
    billingCycle,
    hostingType,
    setHostingType,
  } = props;

  const discountedPrice =
    planName !== "LaunchPad"
      ? (parseFloat(yearPrice) * 0.85).toFixed(2)
      : parseFloat(yearPrice).toFixed(2);

  const selectPlan = (cycle, price, priceId) => {
    setSelectedPlan(cycle);
    onPlanSelect(cycle, price, priceId);
  };

  const [selectedPlan, setSelectedPlan] = useState(billingCycle);

  useEffect(() => {
    onPlanSelect(selectedPlan, discountedPrice);
  }, [discountedPrice]);

  return (
    <Grid2 className={styles.mainContainer}>
      <Grid2 className={styles.planNameContainer}>
        <Grid2 className={styles.iconContainer}>{icon}</Grid2>
        <Grid2 className={styles.planName}>
          {planType === "multi" ? "MS" : "SS"} - {planName}
        </Grid2>
      </Grid2>
      <hr className={styles.line} />
      <Grid2
        className={`${styles.planNameContainer} ${
          explorePlans ? styles.displayFlex : ""
        }`}
      >
        <Grid2 className={styles.header}>
          {explorePlans ? "Select Plan" : "Number of sites"}
        </Grid2>

        {explorePlans && (
          <Grid2 className={styles.clickLabel} onClick={otherPlans}>
            View plan in detail
          </Grid2>
        )}
      </Grid2>
      {!explorePlans && (
        <Grid2 className={styles.planNameContainer}>
          <Grid2 className={styles.label}>
            {`The selected plan allows you to create  ${noOfSites} ${
              noOfSites === "1" ? "Site" : "Sites"
            } `}
          </Grid2>
          <Grid2 className={styles.clickLabel} onClick={otherPlans}>
            Explore more plans
          </Grid2>
        </Grid2>
      )}
      {explorePlans && (
        <ExplorePlans
          licenseInfo={licenseInfo}
          planImages={planImages}
          planType={planType}
          setPlanType={setPlanType}
          toggleType={toggleType}
          setToggleType={setToggleType}
          newPlan={newPlan ? newPlan : initialPlan}
          setNewPlan={setNewPlan}
          setPlanPrice={setPlanPrice}
          country={country}
          onPlanSelect={onPlanSelect}
          onCancel={onCancel}
          userDetails={userDetails}
          setExplorePlans={setExplorePlans}
          hostingType={hostingType}
          setHostingType={setHostingType}
        />
      )}

      <Grid2 className={styles.selectLabel}>Select a plan cycle</Grid2>
      <Grid2 className={styles.planSelectionContainer}>
        <Grid2
          className={`${
            selectedPlan === "Monthly"
              ? styles.selectedPlan
              : styles.planCycleContainer
          }`}
          onClick={() => {
            if (selectedPlan !== "Monthly") {
              selectPlan("Monthly", monthPrice);
              setIsData(null);
            }
          }}
        >
          <Grid2 className={styles.cycleLabel}>Monthly</Grid2>
          <Grid2 className={styles.cyclePrice}>
            {country === "India" ? `₹` : `$`}
            {formatIndianCurrency(monthPrice)}/Mon
          </Grid2>
        </Grid2>
        <Grid2
          className={`${
            selectedPlan === "Yearly"
              ? styles.selectedPlan
              : styles.planCycleContainer
          }`}
          onClick={() => {
            if (selectedPlan !== "Yearly") {
              selectPlan("Yearly", discountedPrice);
              setIsData(null);
            }
          }}
        >
          <Grid2 className={styles.cycleLabel}>Yearly</Grid2>
          <Grid2>
            <Grid2 className={styles.planNameContainer}>
              <Grid2 className={styles.originalAmount}>
                {country === "India" ? `₹` : `$`}
                {monthPrice}/Mon
              </Grid2>
              <Grid2 className={styles.discount}>
                {planName === "LaunchPad" ? "Save 85%" : "Save 15%"}
              </Grid2>
            </Grid2>
            <Grid2 className={styles.cyclePrice}>
              {country === "India" ? `₹` : `$`}
              {formatIndianCurrency((yearPrice / 12).toFixed(2))}/Mon
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}

export default SignUpPlan;
